import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnhealthy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Unhealthy"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="url(#Unhealthy_svg__a)"
      d="M0 14.4C0 6.447 6.447 0 14.4 0h25.2C47.553 0 54 6.447 54 14.4v25.2C54 47.553 47.553 54 39.6 54H14.4C6.447 54 0 47.553 0 39.6z"
      opacity={0.35}
      transform="scale(.37037)"
    />
    <g transform="translate(2.963 2.963)scale(.37037)">
      <circle cx={18.9} cy={18.9} r={15.12} fill="url(#Unhealthy_svg__b)" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M24.77 14.822a.933.933 0 0 0-1.32-1.32l-4.314 4.315-4.314-4.314a.933.933 0 0 0-1.319 1.319l4.314 4.314-4.314 4.314a.933.933 0 0 0 1.32 1.319l4.313-4.314 4.315 4.314a.933.933 0 0 0 1.318-1.319l-4.314-4.314z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M23.05 13.102a1.5 1.5 0 0 1 2.12 2.12l-3.913 3.914 3.913 3.913a1.5 1.5 0 0 1-2.12 2.12l-3.914-3.912-3.913 3.913a1.5 1.5 0 0 1-2.12-2.12l3.913-3.914-3.914-3.913a1.5 1.5 0 0 1 2.121-2.121l3.913 3.913zm-3.914 4.715-4.314-4.314a.933.933 0 0 0-1.319 1.319l4.314 4.314-4.314 4.314a.933.933 0 0 0 1.32 1.319l4.313-4.314 4.315 4.314a.933.933 0 0 0 1.318-1.319l-4.314-4.314 4.314-4.314a.933.933 0 0 0-1.318-1.32z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="Unhealthy_svg__a"
        x1={43.874}
        x2={-23.626}
        y1={39.657}
        y2={38.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E04B44" />
        <stop offset={1} stopColor="#F4AEAC" />
      </linearGradient>
      <linearGradient
        id="Unhealthy_svg__b"
        x1={28.35}
        x2={-9.45}
        y1={25.988}
        y2={25.2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E04B44" />
        <stop offset={1} stopColor="#F4AEAC" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgUnhealthy;
